import React from 'react';
import Devices, { defaultConfigComponent as DeviceConfig } from './Devices';
import { IConfigComponent } from '@ts/ui-models';

export const defaultConfigComponent = (): IConfigComponent => {
  return {
    ...DeviceConfig(),
    componentId: 'devicesToCharge',
    filtersFetchData: {
      device: { isAlive: true },
      deviceType: { isAlive: true },
      deviceTypeCategories: { isAlive: true },
      category: { isAlive: true, logicalId: 'physical' },
      status: 'toCharge',
    },
  };
};

const DevicesToCharge = props => {
  const defaultProps = {
    title: 'Devices to charge',
  };

  return <Devices configComponent={defaultConfigComponent()} {...defaultProps} {...props} />;
};

export default DevicesToCharge;
